import React from 'react';
import PaginationBase from '../../../common/base/PaginationBase';
import { message } from 'antd';



import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import { FACTURA, BOLETA_DE_VENTA, OTROS } from '../../../common/types/tipoComprobanteType';
import { SOLES, DOLARES_AMERICANOS } from '../../../common/types/monedaType';
import { LOGISTICA } from '../../../common/types/sistemaType'
import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';
import auth from '../../../common/utility/auth';

import monedaService from '../../../service/administracion/monedaService';
import listaPrecioService from '../../../service/administracion/listaPrecioService';
import tipoCambioDiarioService from '../../../service/administracion/tipoCambioDiarioService';
import establecimientoService from '../../../service/administracion/establecimientoService';
import almacenService from '../../../service/administracion/almacenService';
import vendedorService from '../../../service/administracion/vendedorService';
import padronReducidoService from '../../../service/integracion/padronReducidoService';
import entidadService from '../../../service/administracion/entidadService';
import proveedorService from '../../../service/administracion/proveedorService';
import tipoComprobanteService from '../../../service/administracion/tipoComprobanteService';
import productoService from '../../../service/administracion/productoService';
import proyectoService from '../../../service/administracion/proyectoService';
import empresaService from '../../../service/administracion/empresaService';
import ordenCompraService from '../../../service/logistica/ordenCompraService';
import conceptoService from '../../../service/logistica/conceptoService';
import movimientoService from '../../../service/logistica/movimientoService';
import { lista_estado_movimiento } from '../../../common/types/ordenCompraEstadoType';

import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModal from './FormModal';
//import BuscarProductoModal from './BuscarProductoModal';
import ImportarOrdenCompraModal from './ImportarOrdenCompraModal';
import FormModalVer from './FormModalVer';
import RenombrarProductoModal from './RenombrarProductoModal';
import AgregarSerieModal from './AgregarSerieModal';
import ImprimirModal from './ImprimirModal';
import DetalleSalida from './DetalleSalida';


import SearchProductModal from './BuscarProductoModal';
import configuracionService from '../../../service/seguridad/usuarioConfiguracionService';

import { APROBADO } from '../../../common/types/ordenCompraEstadoType';
import { ANULADO } from '../../../common/types/movimientoEstadoType';
import { SALIDA } from '../../../common/types/tipoMovimientoType';
import { lst_tipo_afectacion } from '../../../common/types/tipoAfectacion';

var referenciaCount = 1;

export default class Index extends PaginationBase {

    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();

        this.state = {
            loadingSource: true,
            loadingImprimir: false,
            loadingExcel: false,
            loadingPdf: false,
            fetching: false,
            monedas: [],
            tiposCambioDiario: [],
            listasPrecio: [],
            establecimientos: [],
            almacenes: [],
            almacenAll: [],
            estados: lista_estado_movimiento,
            entidades: [],
            clientes: [],
            conceptos: [],
            direcciones: [],
            tiposComprobante: [],
            productos: [],
            proyectos: [],
            ordenesCompra: [],
            almacenUsuario: [],
            company: {},
            filter: {
                idTipoMovimiento: SALIDA.ID,
                fechaInicioStr: global.fetchCurrentDateStr(true),
                fechaFinStr: global.fetchCurrentDateStr(),
                idEstablecimiento: 0,
                tipoReporte: 1,
                idConcepto: 0,
                idEstado: 0,
                entidad: "",
                idProyecto: 0,
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            productoVisible: false,
            importarOCVisible: false,
            visibleVer: false,
            renombrarProductoVisible: false,
            formValues: this.fetchEmptyFormValues(),
            productoModal: {
                nombre: '',
                dataSource: [],
                selectedRowKeys: []
            },
            importarOrdenCompraModal: {
                nombre: '',
                dataSource: [],
                dataSourceDetalle: []
            },
            onSetFieldsValue: null,
            onGetFieldValue: null,
            searchProductVisible: false,
            searchProductFormValues: {
                validarStock: false,
                dataSource: []
            },
            renombrarProductoModal: {
                nombre: '',
                idProducto: 0
            },
            imprimirFormValues: {
                file: undefined,
                idMovimiento: 0
            },
            agregarSerieModal: {
                serie: '',
                idProducto: 0,
                listaDetalleSerie: [],
                selectedRowKeys: []
            },
        }
    }

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleClearFilters = () => {
        var filter = {
            idTipoMovimiento: SALIDA.ID,
            fechaInicioStr: global.fetchCurrentDateStr(true),
            fechaFinStr: global.fetchCurrentDateStr(),
            idEstablecimiento: 0,
            idConcepto: 0,
            idEstado: 0,
            entidad: "",
            idProyecto: 0,
            tipoReporte: 1,
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };

        this.setState({ filter });

        if (property = 'tipoReporte') {
            this._handlePagination(filter)
        }
    };

    handleChangeNameProduct = (row) => {
        console.log(row);
        this.setState({
            renombrarProductoVisible: true,
            renombrarProductoModal: {
                ...this.state.renombrarProductoModal,
                nombre: row.nombre,
                idProducto: row.identifier
            }
        })
    }

    handleOkChangeNameProduct = (value, form) => {
        var listaComprobanteDetalle_aux = this.state.formValues.listaComprobanteDetalle.filter(m => m.identifier !== value.idProducto);

        var currentRow = this.state.formValues.listaComprobanteDetalle.filter(m => m.identifier === value.idProducto)[0];
        currentRow.nombre = value.nombre;
        //console.log(currentRow)
        listaComprobanteDetalle_aux.push(currentRow);

        var empty_renombrarProductoModal = {
            nombre: '',
            idProducto: 0
        };

        form.setFieldsValue(empty_renombrarProductoModal);
        form.resetFields();

        this.setState({
            renombrarProductoVisible: false,
            renombrarProductoModal: {
                ...this.state.renombrarProductoModal,
                nombre: '',
                idProducto: 0
            },
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: listaComprobanteDetalle_aux
            }
        });
    }

    fetchTipoCambio = (idMoneda, tiposCambioDiario) => {
        const filter = (tiposCambioDiario ? tiposCambioDiario : this.state.tiposCambioDiario).filter(m => m.idMoneda === idMoneda);
        if (filter.length > 0)
            return parseFloat(filter[0].compraSunat).toFixed(3);
        else
            return '0.000';
    }

    handleChangeForm = async (property, value, form) => {

        if (property === "fechaStr") {
            //const dias_vencimiento = this.CalcularDiasVencimiento(value, this.state.formValues.fechaVencimientoStr);
            const tiposCambioDiario = await tipoCambioDiarioService.listarPorFecha(value);

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    tipoCambio: this.fetchTipoCambio(DOLARES_AMERICANOS, tiposCambioDiario),
                    //diasVencimiento: dias_vencimiento
                }
            });
        }

        if (property === "idTipoAlmacen") {

            this.setState({ formValues: { ...this.state.formValues, almacenLoading: true } });
            const almacenes = this.state.almacenAll.filter(e => e.idTipoAlmacen == value);

            var idEntidad = this.state.formValues.idEntidad;

            if (value == 2) { //Suministros

                if (idEntidad == "") {
                    form.setFieldsValue({ idTipoAlmacen: undefined });
                    dialog.error('Debe seleccionar un Empleado');
                    return false;
                }
                /*    if (idEntidad.trim().length != 8) {
                       form.setFieldsValue({ idEntidad: undefined });
                       dialog.error('Para Suministros se debe seleccionar un Empleado');
                       return false;
                   } */

            } else {
                if (idEntidad == "") {
                    form.setFieldsValue({ idTipoAlmacen: undefined });
                    dialog.error('Debe seleccionar un Proveedor');
                    return false;
                }

                /*          if (idEntidad.trim().length != 11) {
                             form.setFieldsValue({ idEntidad: undefined });
                             dialog.error('Para Suministros se debe seleccionar un Proveedor');
                             return false;
                         } */
            }
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    almacenLoading: false,
                    almacenes: almacenes ? almacenes : []
                }
            });
        }


        if (property === "idMoneda") {

            var data = form.getFieldValue(property);
            if (this.state.formValues.listaComprobanteDetalle.length > 0) {
                dialog.confirm(<span>Al cambiar la moneda se removera los productos agregados previamente.<br /><span>¿Deseas continuar?'</span></span>,
                    async () => {
                        this.setState({
                            formValues: {
                                ...this.state.formValues,
                                listaComprobanteDetalle: [],
                                detalleProductos: []
                            }
                        });
                        form.setFieldsValue({
                            sumaTotalDetalle: 0,
                            sumaImporteDescuento: 0,
                            sumaSubTotal: 0,
                            sumaIgv: 0,
                            sumaIsc: 0,
                            sumaTotal: 0
                        });
                    }, () => form.setFieldsValue({
                        [property]: data
                    }));
            }
        }

        if (property === "idEstablecimiento" || property === "idAlmacen") {
            var data = form.getFieldValue(property);
            var label = property === "idEstablecimiento" ? "el establecimiento" : 'el almacén';
            if (this.state.formValues.listaComprobanteDetalle.length > 0) {
                dialog.confirm(<span>Al cambiar {label} se removera los productos agregados previamente.<br /><span>¿Deseas continuar?'</span></span>,
                    async () => {
                        if (property === "idEstablecimiento") {
                            this.setState({ formValues: { ...this.state.formValues, almacenLoading: true } });
                            const almacenes = await almacenService.listarPorIdEstablecimiento(value);
                            this.setState({
                                formValues: {
                                    ...this.state.formValues,
                                    almacenLoading: false,
                                    almacenes: almacenes ? almacenes : []
                                }
                            });
                            form.setFieldsValue({
                                idAlmacen: undefined
                            });
                        }

                        this.setState({
                            formValues: {
                                ...this.state.formValues,
                                listaComprobanteDetalle: [],
                                detalleProductos: []
                            }
                        });
                        form.setFieldsValue({
                            sumaTotalDetalle: 0,
                            sumaImporteDescuento: 0,
                            sumaSubTotal: 0,
                            sumaIgv: 0,
                            sumaIsc: 0,
                            sumaTotal: 0,
                            detalleProductos: [],
                            listaComprobanteDetalle: [],
                        });
                    }, () => form.setFieldsValue({
                        [property]: data
                    }));
            } else {
                if (property === "idEstablecimiento") {
                    this.setState({ formValues: { ...this.state.formValues, almacenLoading: true } });
                    //const almacenes = await almacenService.listarPorIdEstablecimiento(value);
                    const param = { idUsuario: auth.user().id, idTipoPermiso: 2, idEstablecimiento: value }
                    const almacenes = await configuracionService.obtenerPermisoAlmacen(param); // 2 logisitica

                    this.setState({
                        formValues: {
                            ...this.state.formValues,
                            almacenLoading: false,
                            almacenes: almacenes ? almacenes : []
                        },
                        almacenAll: almacenes ? almacenes : []

                    });
                    form.setFieldsValue({
                        idAlmacen: undefined,
                        detalleProductos: [],
                        listaComprobanteDetalle: [],
                    });
                }
            }
        }
    }

    fetchEmptyFormValues = () => {
        return {
            id: 0,
            idEntidad: 0, //..........................................................OK
            idEstablecimientoCliente: 0, //..........................................................OK
            idAlmacen: 0, //..........................................................OK
            idMoneda: SOLES, //..........................................................OK
            idListaPrecio: 0, //..........................................................OK
            idEstablecimiento: 0, //..........................................................OK
            idProyecto: 0,
            serie: "S001", //............................................... OK
            documento: "", //............................................... OK
            fechaStr: global.fetchCurrentDateStr(), //......................................... OK
            fechaVencimientoStr: global.fetchCurrentDateStr(), //......................................... OK
            diasVencimiento: 0, //..........................................................OK
            tipoCambio: 0, //..........................................................OK
            observacion: "", //..........................................................OK
            detalleProductos: [],
            listaComprobanteDetalle: [],
            listaComprobanteReferencia: [],
            sumaSubTotal: 0,
            sumaIgv: 0,
            sumaTotal: 0,
            almacenLoading: false,
            clienteLoading: false,
            flagTipoBusquedaScanner: 0,
            activeKey: "1",
            documentoEntidad: "",
            monedas: [],
            listasPrecio: [],
            establecimientos: [],
            almacenes: [],
            clientes: [],
            entidades: [],
            direcciones: [],
            tiposComprobante: [],
            proyectos: [],
            conceptos: [],
            idOrdenCompra: 0,
            ordenesCompra: [],
            TipoAlmacen: [],
            idConcepto: 0,
            idTipoAlmacen: 0,
            flagclaim: false,
            claim: ''

        }
    }

    fetchEditFormValues = (value) => {
        //var d = new Date();
        //var _year = d.getFullYear();
        return {
            id: value.movimiento.id,
            idEntidad: value.movimiento.idEntidad, //..........................................................OK
            //idEstablecimientoCliente: 0, //..........................................................OK
            idAlmacen: value.movimiento.idAlmacen, //..........................................................OK
            idMoneda: value.movimiento.idMoneda, //..........................................................OK
            idListaPrecio: 0, //..........................................................OK
            idEstablecimiento: value.movimiento.idEstablecimiento, //..........................................................OK
            idProyecto: value.movimiento.idProyecto,
            serie: value.movimiento.serie, //............................................... OK
            documento: value.movimiento.documento, //............................................... OK
            fechaStr: value.movimiento.fechaStr, //......................................... OK
            //fechaVencimientoStr: global.fetchCurrentDateStr(), //......................................... OK
            diasVencimiento: 0, //..........................................................OK
            tipoCambio: value.movimiento.tipoCambio, //..........................................................OK
            observacion: value.movimiento.observacion, //..........................................................OK
            listaComprobanteDetalle: [],
            listaComprobanteReferencia: [],
            sumaSubTotal: value.movimiento.subTotal,
            sumaIgv: value.movimiento.igv,
            sumaTotal: value.movimiento.total,
            almacenLoading: false,
            clienteLoading: false,
            activeKey: "1",
            documentoEntidad: value.movimiento.numeroDocumentoEntidad,
            monedas: [],
            listasPrecio: [],
            establecimientos: [],
            almacenes: [],
            clientes: [],
            entidades: [],
            direcciones: [],
            tiposComprobante: [],
            proyectos: [],
            conceptos: [],
            idOrdenCompra: 0,
            ordenesCompra: [],
            idConcepto: value.movimiento.idConcepto,
            idTipoAlmacen: value.movimiento.idTipoAlmacen,

            razonSocialEntidad: value.movimiento.razonSocialEntidad,
            nombreEstablecimiento: value.movimiento.nombreEstablecimiento,
            nombreAlmacen: value.movimiento.nombreAlmacen,
            nombreConcepto: value.movimiento.nombreConcepto,
            nombreTipoMovimiento: value.movimiento.nombreTipoMovimiento,
            nombreMoneda: value.movimiento.nombreMoneda,
            nombreProyecto: value.movimiento.nombreProyecto,
            flagclaim: false,
            claim: value.movimiento.claim
        }
    }

    fetchEmptyFormResetValues = () => {
        var d = new Date();
        var _year = d.getFullYear();
        return {
            id: 0,
            idEntidad: 0, //..........................................................OK
            idEstablecimientoCliente: 0, //..........................................................OK
            idAlmacen: 0, //..........................................................OK
            idMoneda: SOLES, //..........................................................OK
            idListaPrecio: 0, //..........................................................OK
            idEstablecimiento: 0, //..........................................................OK
            idProyecto: 0,
            serie: _year, //............................................... OK
            documento: "", //............................................... OK
            //fechaStr: global.fetchCurrentDateStr(), //......................................... OK
            //fechaVencimientoStr: global.fetchCurrentDateStr(), //......................................... OK
            diasVencimiento: 0, //..........................................................OK
            tipoCambio: 0, //..........................................................OK
            observacion: "", //..........................................................OK
            listaComprobanteDetalle: [],
            listaComprobanteReferencia: [],
            //sumaTotalDetalle: 0,
            //sumaImporteDescuento: 0,
            sumaSubTotal: 0,
            sumaIgv: 0,
            sumaTotal: 0,
            almacenLoading: false,
            clienteLoading: false,
            activeKey: "1",
            documentoEntidad: "",
            monedas: [],
            listasPrecio: [],
            establecimientos: [],
            almacenes: [],
            clientes: [],
            entidades: [],
            direcciones: [],
            tiposComprobante: [],
            proyectos: [],
            conceptos: [],
            idOrdenCompra: 0,
            ordenesCompra: [],
            idConcepto: 0,
            TipoAlmacen: [],
            idTipoAlmacen: 0,
            flagclaim: false,
            claim: ''
        }
    }

    handleAddReferencia = () => {
        var listaComprobanteReferencia = this.state.formValues.listaComprobanteReferencia;

        listaComprobanteReferencia.push({
            identifier: global.fetchUniqueCode(),
            idReferencia: 0,
            idReferenciaOrigen: 0,
            idTipoComprobante: 0,
            serie: "",
            documento: "",
            flagInterno: true
        });

        referenciaCount = referenciaCount + 1;

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteReferencia: listaComprobanteReferencia
            }
        });
    };

    handleRemoverReferencia = (id) => {
        var listaComprobanteReferencia = this.state.formValues.listaComprobanteReferencia.filter(m => m.identifier !== id.identifier);
        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteReferencia: listaComprobanteReferencia
            },
        });
    }

    handleOpenSearchProductModal = async () => {
        debugger;
        var idAlmacen = this.state.onGetFieldValue('idAlmacen');
        var idMoneda = this.state.onGetFieldValue('idMoneda');
        if (idAlmacen === undefined || idAlmacen.key === 0) {
            message.warning('Por favor seleccione un almacén.');
            return;
        }

        var filter = {
            idAlmacen: idAlmacen === undefined ? 0 : idAlmacen.key,
            idMoneda: idMoneda === undefined ? 0 : idMoneda.key,
            idSistema: LOGISTICA,
            barcode: '',
        }

        const response = await productoService.stock(filter);

        this.setState({
            searchProductVisible: true,
            searchProductFormValues: {
                ...this.state.searchProductFormValues,
                validarStock: response.validarStock,
                dataSource: response.productos
            }
        });
    }

    handleBuscarProducto = async (value) => {

        var idAlmacen = this.state.onGetFieldValue('idAlmacen');
        var idMoneda = this.state.onGetFieldValue('idMoneda');

        if (idAlmacen === undefined || idAlmacen.key === 0) {
            message.warning('Por favor seleccione un almacén.');
            return;
        }

        var filter = {
            idAlmacen: idAlmacen === undefined ? 0 : idAlmacen.key,
            idMoneda: idMoneda === undefined ? 0 : idMoneda.key,
            idSistema: LOGISTICA,
            codigoNombre: value
        }

        const response = await productoService.stock(filter);
        this.setState({
            searchProductVisible: true,
            searchProductFormValues: {
                ...this.state.searchProductFormValues,
                validarStock: response.validarStock,
                dataSource: response.productos
            }
        });
    };

    handleChangeProductoModal = (value) => {
        const dataSource = this.state.productos.filter(item => {
            return (item.codigoReferencia + ' - ' + item.nombre)
                .toUpperCase()
                .match(value.toUpperCase());
        });

        this.setState({
            productoModal: {
                ...this.state.productoModal,
                dataSource: dataSource
            }
        });
    };

    handleScaner = async (value, onSetFieldsValue, onGetFieldValue, onCalculateDetail) => {
        debugger;
        this.setState({
            onSetFieldsValue,
            onGetFieldValue,
        });

        //SE AGREGA PRODUCTO POR CODIGO DE BARRA
        var idEstablecimiento = this.state.onGetFieldValue('idEstablecimiento');
        var idAlmacen = this.state.onGetFieldValue('idAlmacen');
        var idMoneda = this.state.onGetFieldValue('idMoneda');
        var flagTipoBusquedaScanner = this.state.onGetFieldValue('flagTipoBusquedaScanner') === undefined ? 0 : this.state.onGetFieldValue('flagTipoBusquedaScanner');

        if (idEstablecimiento === undefined) {
            message.warning('Por favor seleccione un establecimiento.');
            return;
        }

        if (idAlmacen === undefined) {
            message.warning('Por favor seleccione un almacén.');
            return;
        }

        if (idMoneda === undefined) {
            message.warning('Por favor seleccione la moneda.');
            return;
        }
        var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle;


        if (this.state.agregarSerieVisible) { // SE AGREGA SERIE MENDIANTE EL POPUP ASIGNAR SERIE

            var filter_producto_detalle = listaComprobanteDetalle.filter((m) => m.idProducto === this.state.agregarSerieModal.idProducto)[0];

            if (filter_producto_detalle.listaDetalleSerie.filter(m => m.serie === value).length > 0) {
                message.warning('La serie ya ha sido agregada.');
                return;
            }

            var listaSerieProducto = await movimientoService.listarSeriesDisponibles({ idAlmacen: idAlmacen.key, idProducto: this.state.agregarSerieModal.idProducto, numeroLote: filter_producto_detalle.lote });
            var serieProducto = listaSerieProducto.filter(m => m.serie === value);

            if (serieProducto.length === 0) {
                message.warning('El número de serie no existe.');
                return;
            }

            filter_producto_detalle.listaDetalleSerie.push(serieProducto[0]);

            var selected = filter_producto_detalle.listaDetalleSerie.map(m => m.serie);

            this.handleChangeSelectedSerie(selected, filter_producto_detalle.listaDetalleSerie, onCalculateDetail, 0);

            return;
        }
        else if (flagTipoBusquedaScanner === 0) // BUSQUEDA DE PRODUCTO POR CODIGO DE BARRA
        {
            //SE AGREGA PRODUCTO POR CODIGO DE BARRA 

            var filter_detalle = listaComprobanteDetalle.filter((m) => m.codigoBarra === value);

            const index = listaComprobanteDetalle.map(i => i.codigoBarra).indexOf(value);

            var item = {};
            if (filter_detalle.length > 0) {
                listaComprobanteDetalle = listaComprobanteDetalle.filter((m) => m.codigoBarra !== value);

                var item = filter_detalle[0];

                if (item.flagAplicarSerie) {
                    dialog.error("El producto ya se encuentra agregado.");
                    return;
                }

                var item = filter_detalle[0];
                var _precioUnitario = this.state.onGetFieldValue(`arrPrecioUnitario[${item.identifier}]`);
                var _cantidad = this.state.onGetFieldValue(`arrCantidad[${item.identifier}]`);

                item.cantidad = parseInt(_cantidad,) + 1;

                item.precioUnitario = parseFloat(_precioUnitario);
            } else {

                var filter = {
                    idAlmacen: idAlmacen === undefined ? 0 : idAlmacen.key,
                    idMoneda: idMoneda === undefined ? 0 : idMoneda.key,
                    idSistema: LOGISTICA,
                    barcode: value,
                }

                var list = await productoService.stock(filter);

                var filter_list = list.productos.filter((m) => m.codigoBarra === value);

                if (filter_list.length === 0) {
                    dialog.error("No existe el producto con codigo " + value + "\n" + "o no cuenta con stock");
                    return;
                }

                item = this.setDetalleByProductoStock(filter_list[0]);
            }

            listaComprobanteDetalle.splice(index, 0, item);

            var detalleProductos = this.state.onGetFieldValue("detalleProductos");
            detalleProductos = detalleProductos.filter((m) => m.identifier !== item.identifier);

            this.setState(
                {
                    formValues: {
                        ...this.state.formValues,
                        listaComprobanteDetalle: listaComprobanteDetalle
                    },
                },
                () => {
                    detalleProductos.splice(index, 0, item);
                    this.state.onSetFieldsValue({
                        detalleProductos: detalleProductos
                    });
                    onCalculateDetail(item, item.idProducto, "arrCantidad", item.cantidad, 3);
                }
            );
            message.success("Producto agregado");
        }
        else if (flagTipoBusquedaScanner === 1)  // BUSQUEDA DE PRODUCTO POR SERIE
        {
            debugger;
            var listaSerieProducto = await movimientoService.listarSeriesDisponiblesBySerie({ idAlmacen: idAlmacen.key, serie: value });

            if (listaSerieProducto.length === 0) {
                message.warning('El número de serie no existe.');
                return;
            }

            var count_productos_by_serie = listaSerieProducto.map(item => item.idProducto).filter((value, index, self) => self.indexOf(value) === index);

            if (count_productos_by_serie.length > 1) {
                message.warning('La serie tiene asociado mas de un producto, no se puede escanear.');
                return;
            }

            var serieProducto = listaSerieProducto[0];

            var comprobanteDetalle_filter = listaComprobanteDetalle.filter(m => m.idProducto === serieProducto.idProducto && m.lote == serieProducto.numeroLote);
            debugger;
            var item = {};
            if (comprobanteDetalle_filter.length > 0) {
                item = comprobanteDetalle_filter[0];

                if (item.listaDetalleSerie.filter(m => m.serie === value).length > 0) {
                    message.warning('La serie ya ha sido agregado.');
                    return;
                }

                var _precioUnitario = this.state.onGetFieldValue(`arrPrecioUnitario[${item.identifier}]`);
                var _cantidad = this.state.onGetFieldValue(`arrCantidad[${item.identifier}]`);

                item.cantidad = parseInt(_cantidad,) + 1;
                item.listaDetalleSerie.push(serieProducto);
                item.precioUnitario = parseFloat(_precioUnitario);

                var listaComprobanteDetalleFilter = listaComprobanteDetalle.filter(m => m.identifier != item.identifier);

                listaComprobanteDetalleFilter.push(item);

                listaComprobanteDetalle = listaComprobanteDetalleFilter;

            } else {
                var filter = {
                    idAlmacen: idAlmacen === undefined ? 0 : idAlmacen.key,
                    idMoneda: idMoneda === undefined ? 0 : idMoneda.key,
                    idSistema: LOGISTICA,
                    barcode: ''
                }

                const response = await productoService.stock(filter);

                var producto = response.productos.filter(m => m.id === serieProducto.idProducto && m.numeroLote === serieProducto.numeroLote)[0];

                item = this.setDetalleByProductoStock(producto);

                item.listaDetalleSerie.push(serieProducto);
                item.detalleSeries = item.listaDetalleSerie.map(u => u.serie).join(', ');
                item.cantidad = item.listaDetalleSerie.length;

                listaComprobanteDetalle.push(item);
            }

            var selected = item.listaDetalleSerie.map(m => m.serie);

            var detalleProductos = this.state.onGetFieldValue("detalleProductos");

            this.setState(
                {
                    formValues: {
                        ...this.state.formValues,
                        listaComprobanteDetalle: listaComprobanteDetalle
                    },
                },
                () => {
                    detalleProductos.push(item);
                    this.state.onSetFieldsValue({
                        detalleProductos: detalleProductos
                    });

                    this.handleChangeSelectedSerie(selected, item.listaDetalleSerie, onCalculateDetail, 0);
                }
            );
        }
    };

    setDetalleByProductoStock = (row) => {
        var item = {
            identifier: global.fetchUniqueCode(),
            idProducto: row.id,
            codigo: row.codigoReferencia,
            codigoBarra: row.codigoBarra,
            nombre: row.nombre,
            nombreUnidadMedida: row.nombreUnidadMedida,
            flagAfecto: row.flagIGVAfecto,
            precioUnitario: row.precioPromedio,
            stock: row.stockDisponible,
            flagAplicarSerie: row.flagAplicarSerie,
            cantidad: row.flagAplicarSerie ? 0 : 1,
            subTotal: 0,
            igv: 0,
            total: 0,
            precioUnitarioSinIGV: 0,
            fechaVencimiento: this.state.formValues.fechaStr,
            lote: row.numeroLote,
            minFechaStr: this.getMinDate(this.state.formValues.fechaStr),
            listaDetalleSerie: []
        };
        return item;
    };


    // handleChangeSelectedRowKey = (selected, rows) => {

    //     var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle;

    //     rows.forEach(item => {
    //         var filter = this.state.formValues.listaComprobanteDetalle.filter(m => { return m.idProducto === item.id; });
    //         if (filter.length === 0) {

    //             listaComprobanteDetalle.push({
    //                 idProducto: item.id,
    //                 nombre: item.nombre,
    //                 cantidad: 0,
    //                 codigoBarra: item.codigoBarra,
    //                 codigo: item.codigoReferencia,
    //                 nombreUnidadMedida: item.nombreUnidadMedida,
    //                 precioUnitario: item.precioUnitario,
    //                 total: 0,
    //                 flagAfecto: item.flagIGVAfecto,
    //                 precioUnitarioSinIGV: 0,
    //                 subTotal: 0,
    //                 igv: 0,
    //                 fechaVencimiento: null,
    //                 lote: ''
    //             })
    //         }
    //     });

    //     listaComprobanteDetalle = listaComprobanteDetalle.filter(m => selected.filter(f => f === m.idProducto).length);

    //     this.setState({
    //         formValues: {
    //             ...this.state.formValues,
    //             listaComprobanteDetalle: listaComprobanteDetalle
    //         },
    //         productoModal: {
    //             ...this.state.productoModal,
    //             selectedRowKeys: selected
    //         }
    //     });
    // };

    handleChangeTab = (key) => {
        this.setState({
            formValues: {
                ...this.state.formValues,
                activeKey: key
            }
        });
    };

    handleAgregarDetalle = (onSetFieldsValue, onGetFieldValue) => {
        this.setState({
            onSetFieldsValue,
            onGetFieldValue
        }, () => {
            if (this.state.formValues.activeKey === "1")
                this.handleOpenSearchProductModal();

            if (this.state.formValues.activeKey === "2")
                this.handleAddReferencia();
        });
    };

    //handleAddReferencia = () => {
    //    var listaComprobanteReferencia = this.state.formValues.listaComprobanteReferencia;

    //    listaComprobanteReferencia.push({
    //        identifier: referenciaCount,
    //        idReferencia: 0,
    //        idReferenciaOrigen: 0,
    //        idTipoComprobante: 0,
    //        series: "",
    //        documentos: "",
    //        flagInterno: true
    //    });

    //    referenciaCount = referenciaCount + 1;

    //    this.setState({
    //        formValues: {
    //            ...this.state.formValues,
    //            listaComprobanteReferencia: listaComprobanteReferencia
    //        }
    //    });
    //};

    handleOnChangeEntidad = async (value, form) => {

        //const numeroDoc = value.props.children.split('-')[value.props.children.split('-').length - 1];
        this.setState({
            formValues: {
                ...this.state.formValues,
                //documentoEntidad: numeroDoc,
                idEntidad: value,
                direcciones: []
            }
        });

        form.setFieldsValue({ idTipoAlmacen: { key: undefined } });
        form.setFieldsValue({ idEntidad: value });


        const direccionesEstablecimientos = await establecimientoService.listarPorIdEntidad(value);
        if (direccionesEstablecimientos === undefined) {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    //clienteLoading: false,
                    //clientes: [],
                    direcciones: [],
                    documentoEntidad: ''
                }
            });
        } else {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    direcciones: direccionesEstablecimientos
                }
            });
        }
    }

    handleSearchClientes = async (value) => {
        if (!value) return;

        this.setState({ fetching: true });

        setTimeout(async () => {
            const response = await entidadService.search({ valor: value });

            if (response !== undefined) {
                this.setState({
                    formValues: {
                        ...this.state.formValues,
                        clienteLoading: false,
                        entidades: response,
                        direcciones: [],
                    },
                    fetching: false
                });
            }
        }, 800);

    };



    handleBuscarEntidad = async (value) => {

        if (value.length > 2) {


            this.setState({ formValues: { ...this.state.formValues, clienteLoading: true } });

            const filter = {
                numeroDocumento: value,
                idTipoComprobante: OTROS.ID// FACTURA.ID
            }

            //const response = await padronReducidoService.obtenerPorDocumentoTipoComprobante(filter);
            const response = await entidadService.obtenerTodos(filter);

            if (response === undefined) {
                this.setState({
                    formValues: {
                        ...this.state.formValues,
                        clienteLoading: false,
                        entidades: [],
                        direcciones: [],
                    }
                });
            }
            else {

                const resultFilter = response.filter(item => {
                    return (item.numeroDocumento + ' - ' + item.nombre)
                        .toUpperCase()
                        .match(value.toUpperCase());
                });

                console.log(resultFilter)

                this.setState({
                    formValues: {
                        ...this.state.formValues,
                        clienteLoading: false,
                        entidades: resultFilter,
                        direcciones: []
                        //direcciones: response.direcciones,
                        //idEntidad: response.clientes.length > 0 ? response.clientes[0].id : 0,
                        //idEstablecimientoCliente: response.direcciones.length > 0 ? response.direcciones[0].id : 0
                    }
                });
            }

        } else {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    clienteLoading: false,
                    clientes: [],
                    direcciones: [],
                }
            });
        }

    };

    handleImportarOC = () => {
        debugger
        this.setState({
            importarOCVisible: true,
            ImportarOrdenCompraModal: {
                ...this.state.ImportarOrdenCompraModal,
                dataSource: this.state.ordenesCompra,
                dataSourceDetalle: []
            }
        })
    }

    handleNew = async () => {
        //debugger
        var idSoles = SOLES;
        var formValues = this.fetchEmptyFormValues();
        formValues.monedas = this.state.monedas;
        formValues.tipoCambio = this.fetchTipoCambio(DOLARES_AMERICANOS);
        formValues.listasPrecio = this.state.listasPrecio.filter(m => m.id === idSoles);
        formValues.establecimientos = this.state.almacenUsuario;
        formValues.idListaPrecio = formValues.listasPrecio.length === 0 ? 0 : formValues.listasPrecio[0].id;
        formValues.tiposComprobante = this.state.tiposComprobante;
        formValues.proyectos = this.state.proyectos;
        formValues.conceptos = this.state.conceptos;
        formValues.entidades = this.state.entidades;
        formValues.TipoAlmacen = this.state.TipoAlmacen;
        formValues.flagClaim = this.state.company.idTipoEmpresa == 2 ? true : false;
        formValues.tipoAfectacion = lst_tipo_afectacion;

        var filterSearchOC = {
            idEstadoRequerimiento: APROBADO,
            filtro: ''
        };

        var productos = await productoService.listarPorIdListaPrecio(formValues.idListaPrecio);
        var ordenesCompra = await ordenCompraService.listarPorEstado(filterSearchOC);
        //debugger
        this.setState({
            visible: true,
            formValues,
            productos: productos ? productos : [],
            productoModal: {
                ...this.state.productoModal,
                selectedRowKeys: []
            },
            ordenesCompra: ordenesCompra ? ordenesCompra : [],
            importarOrdenCompraModal: {
                ...this.state.importarOrdenCompraModal,
                selectedRowKeys: []
            }
        });
    }

    handleSave = async (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            debugger

            if (values.movimientoDetalles !== undefined) {
                for (var i = 0; i < values.movimientoDetalles.length; i++) {
                    var item = this.state.formValues.listaComprobanteDetalle.filter(m => m.identifier === values.movimientoDetalles[i].identifier)[0];
                    values.movimientoDetalles[i].nombre = item.nombre;
                }
            }

            var response;
            if (values.id === 0 || values.id === undefined)
                response = await movimientoService.registrar(values);
            else
                response = await movimientoService.modificar(values);

            if (response.status === 200) {
                var empty = this.fetchEmptyFormResetValues();
                this.setState({ visible: false, formValues: empty });
                form.setFieldsValue(empty);
                form.resetFields();

                if (values.id === 0)
                    message.success('Registrado correctamente.');
                else
                    message.success('Modificado correctamente.');

                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleExportExcel = async () => {
        this.setState({ loadingExcel: true });

        var response = await movimientoService.excel(this.state.filter);
        this.setState({ loadingExcel: false });

        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Salidas.xlsx");
    }

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await movimientoService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Salidas.pdf");
    }

    handlePrint = async () => {
        this.setState({ loadingPrint: true });
        var response = await movimientoService.pdf(this.state.filter);
        this.setState({ loadingPrint: false });
        if (response !== undefined) {
            var file = window.URL.createObjectURL(response.data);
            var win = window.open(file, '_blank');
            win.focus();
        }
    }

    handleImprimir = async (item) => {
        this.setState({ loadingImprimir: true })
        var file = undefined;
        var response = await movimientoService.pdfA4({ id: item.id });
        file = window.URL.createObjectURL(response.data);

        this.setState({
            imprimirVisible: true,
            loadingImprimir: false,
            imprimirFormValues: {
                ...this.state.imprimirFormValues,
                file,
                idOrdenCompra: item.id
            }
        });
    };

    handleDetalleExportExcel = async () => {
        this.setState({ loadingExcel: true });

        var response = await movimientoService.excelDetallado(this.state.filter);
        this.setState({ loadingExcel: false });

        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Salidas Detallado.xlsx");
    }

    handleDetalleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await movimientoService.pdfDetallado(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Salidas Detallado.pdf");
    }


    handleEdit = async (values) => {

        const response = await movimientoService.obtenerPorId(values.id);
        if (response !== undefined) {
            var filterSearchOC = {
                idEstadoRequerimiento: APROBADO,
                filtro: ''
            };
            var formValues = this.fetchEditFormValues(response);
            formValues.monedas = this.state.monedas;
            formValues.tipoCambio = this.fetchTipoCambio(DOLARES_AMERICANOS);
            formValues.listasPrecio = this.state.listasPrecio.filter(m => m.id === SOLES);
            formValues.establecimientos = this.state.establecimientos;
            formValues.idListaPrecio = formValues.listasPrecio.length === 0 ? 0 : formValues.listasPrecio[0].id;
            formValues.tiposComprobante = this.state.tiposComprobante;
            formValues.proyectos = this.state.proyectos;
            formValues.conceptos = this.state.conceptos;
            formValues.flagClaim = this.state.company.idTipoEmpresa == 2 ? true : false;
            formValues.tipoAfectacion = lst_tipo_afectacion;

            var productos = await productoService.listarPorIdListaPrecio(formValues.idListaPrecio);
            var ordenesCompra = await ordenCompraService.listarPorEstado(filterSearchOC);

            const filterEntidad = {
                numeroDocumento: response.movimiento.numeroDocumentoEntidad,
                idTipoComprobante: OTROS.ID// FACTURA.ID
            }
            const almacenes = await almacenService.listarPorIdEstablecimiento(response.movimiento.idEstablecimiento);
            const entidades = await entidadService.obtenerTodos(filterEntidad);

            formValues.entidades = entidades;
            formValues.almacenes = almacenes;

            const products = [];
            for (var i = 0; i < response.movimientoDetalles.length; i++) {
                var item = response.movimientoDetalles[i];
                var oneProd = {
                    identifier: global.fetchUniqueCode(),
                    idProducto: item.idProducto,
                    nombre: item.nombre,
                    cantidad: item.cantidad,
                    codigo: item.codigoReferencia,
                    nombreUnidadMedida: item.nombreUnidadMedida,
                    precioUnitario: item.precioUnitario,
                    total: item.total,
                    flagAfecto: item.flagAfecto,
                    precioUnitarioSinIGV: 0,
                    subTotal: item.subTotal,
                    igv: item.igv,
                    lote: item.numeroLote,
                    idImpuesto: item.idImpuesto,

                    //fechaVencimiento: item.fechaStr
                }

                formValues.listaComprobanteDetalle.push(oneProd);

                products.push(item.idProducto);
            }

            for (var i = 0; i < response.movimientoReferencias.length; i++) {
                referenciaCount = i + 1;
                var item = response.movimientoReferencias[i];
                var oneRef = {
                    identifier: referenciaCount,
                    idReferencia: item.id,
                    idReferenciaOrigen: item.idReferenciaOrigen,
                    idTipoComprobante: item.idTipoComprobante,
                    serie: item.serie,
                    documento: item.documento,
                    flagInterno: true
                }
                formValues.listaComprobanteReferencia.push(oneRef);
            }
            console.log(formValues);
            //debugger
            this.setState({
                visible: true,
                formValues,
                productos: productos ? productos : [],
                productoModal: {
                    ...this.state.productoModal,
                    selectedRowKeys: []
                },
                ordenesCompra: ordenesCompra ? ordenesCompra : [],
                importarOrdenCompraModal: {
                    ...this.state.importarOrdenCompraModal,
                    selectedRowKeys: []
                }
            });
        }
    }

    handleVer = async (values) => {
        const response = await movimientoService.obtenerPorId(values.id);

        if (response !== undefined) {
            var formValues = this.fetchEditFormValues(response);
            //console.log(formValues)
            const almacenes = await almacenService.listarPorIdEstablecimiento(response.movimiento.idEstablecimiento);

            for (var i = 0; i < response.movimientoDetalles.length; i++) {
                var item = response.movimientoDetalles[i];

                const listaCompraDetalleSerie = [];

                response.movimientoDetalleSerie.forEach((detalleSerie) => {
                    if (detalleSerie.idProducto === item.idProducto) {
                        listaCompraDetalleSerie.push({
                            // identifier: global.fetchUniqueCode(),
                            idProducto: detalleSerie.idProducto,
                            serie: detalleSerie.serie
                        });
                    }
                });

                var oneProd = {
                    idProducto: item.idProducto,
                    nombre: item.nombre,
                    cantidad: item.cantidad,
                    codigo: item.codigoReferencia,
                    nombreUnidadMedida: item.nombreUnidadMedida,
                    precioUnitario: item.precioUnitario,
                    total: item.total,
                    flagAfecto: item.flagAfecto,
                    precioUnitarioSinIGV: item.valorUnitario,
                    subTotal: item.subTotal,
                    igv: item.igv,
                    lote: item.numeroLote,
                    fechaVencimiento: item.fechaStr,
                    idImpuesto: item.idImpuesto,
                    tipoImpuesto: item.tipoImpuesto,
                    detalleSeries: listaCompraDetalleSerie.map(u => u.serie).join(', '),
                    listaCompraDetalleSerie: listaCompraDetalleSerie
                }

                formValues.listaComprobanteDetalle.push(oneProd);

            }

            for (var i = 0; i < response.movimientoReferencias.length; i++) {
                referenciaCount = i + 1;
                var item = response.movimientoReferencias[i];
                var oneRef = {
                    identifier: referenciaCount,
                    idReferencia: item.id,
                    idReferenciaOrigen: item.idReferenciaOrigen,
                    idTipoComprobante: item.idTipoComprobante,
                    serie: item.serie,
                    documento: item.documento,
                    flagInterno: true,
                    nombreTipoComprobante: item.nombreTipoComprobante
                }
                formValues.listaComprobanteReferencia.push(oneRef);
            }
            formValues.almacenes = almacenes;
            formValues.TipoAlmacen = this.state.TipoAlmacen;

            this.setState({
                visibleVer: true,
                formValues
            });
        }
    }

    handleAnular = async (values) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            debugger
            var data = {
                id: values.id,
                idMovimientoEstado: ANULADO
            };
            var response = await movimientoService.actualizarEstado(data);

            if (response.status === 200) {
                var empty = this.fetchEmptyFormValues();
                this.setState({ visible: false, formValues: empty });

                message.success('Registrado anulado correctamente.');

                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    }

    getMinDate = (value) => {
        var arrayD1 = value.split('/');
        var minDate = arrayD1[2] + "/" + arrayD1[1] + "/" + arrayD1[0];

        return minDate;
    }

    handleSelectProduct = (row) => {
        var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle;
        var producto = listaComprobanteDetalle.filter(e => e.nombre == row.nombre && e.lote == row.numeroLote);
        if (producto.length > 0) {
            message.error("No se puede duplicar el producto");

            return false;
        }
        var detalleProductos = this.state.formValues.detalleProductos;
        var dateVcto = row.flagVencimiento ? row.fechaVencimientoStr : this.state.formValues.fechaStr;

        var item = {
            identifier: global.fetchUniqueCode(),
            idProducto: row.id,
            codigo: row.codigoReferencia,
            nombre: row.nombre,
            nombreUnidadMedida: row.nombreUnidadMedida,
            flagAfecto: row.flagIGVAfecto,
            flagAplicarSerie: row.flagAplicarSerie,
            precioUnitario: row.precioPromedio,
            stock: row.stockDisponible,
            cantidad: 0,
            subTotal: 0,
            igv: 0,
            total: 0,
            precioUnitarioSinIGV: 0,
            fechaVencimiento: dateVcto,
            flagVencimiento: row.flagVencimiento,
            lote: row.numeroLote,
            idImpuesto: row.idImpuesto,
            minFechaStr: this.getMinDate(this.state.formValues.fechaStr),
            listaDetalleSerie: [],
            selectedSerie: []
        };

        var producto = {
            identifier: item.identifier,
            codigo: row.codigoReferencia,
            nombre: row.nombre,
            idProducto: item.idProducto,
            nombreUnidadMedida: row.nombreUnidadMedida,
            cantidad: item.cantidad,
            stock: row.stockDisponible,
            igv: item.igv,
            precioUnitario: item.precioPromedio,
            total: item.total,
            flagAfecto: item.flagAfecto,
            flagAplicarSerie: row.flagAplicarSerie,
            subTotal: 0,
            fechaVencimiento: this.state.formValues.fechaStr,
            lote: item.lote,
            idImpuesto: row.idImpuesto,
            minFechaStr: this.getMinDate(this.state.formValues.fechaStr),
            listaDetalleSerie: [],
            selectedSerie: []
        };

        listaComprobanteDetalle.push(item);

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: listaComprobanteDetalle,
                detalleProductos: detalleProductos
            }
        }, () => {

            var detalleProductos = this.state.onGetFieldValue('detalleProductos');
            detalleProductos.push(producto);
            this.state.onSetFieldsValue({ detalleProductos });
        }
        );
    };

    // handleRemoverProducto = (row) => {
    //     this.setState({
    //         formValues: {
    //             ...this.state.formValues,
    //             listaComprobanteDetalle: this.state.formValues.listaComprobanteDetalle.filter(m => m.identifier !== row.identifier)
    //         },
    //     }//,
    //         //() => {
    //         //    var detalleProductos = this.state.onGetFieldValue('detalleProductos');
    //         //    this.state.onSetFieldsValue({
    //         //        detalleProductos: detalleProductos.filter(m => m.identifier !== row.identifier)
    //         //    });
    //         //}
    //     );
    // };

    // handleRemoverProducto = (id) => {
    //     
    //     var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle.filter(m => m.idProducto !== id);
    //     var detalleProductos = this.state.formValues.detalleProductos.filter(m => m.idProducto !== id);
    //     var selectedRowKeys = this.state.productoModal.selectedRowKeys.filter(m => m !== id);

    //     this.setState({
    //         formValues: {
    //             ...this.state.formValues,
    //             listaComprobanteDetalle: listaComprobanteDetalle,
    //             detalleProductos:detalleProductos
    //         },
    //         productoModal: {
    //             ...this.state.productoModal,
    //             selectedRowKeys: selectedRowKeys
    //         }
    //     }, () => {
    //         this.state.onSetFieldsValue({ detalleProductos });
    //     });
    // };


    handleRemoverProducto = (row, form) => {

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: this.state.formValues.listaComprobanteDetalle.filter(m => m.identifier !== row.identifier)
            },
        }, () => {
            var detalleProductos = form.getFieldValue('detalleProductos');
            form.setFieldsValue({
                detalleProductos: detalleProductos.filter(m => m.identifier !== row.identifier)
            });
        });
    };

    handleAgregarSerie = async (row, onCalculateDetail, setFieldsValueDetalle, getFieldValueDetalle) => {
        var idAlmacen = this.state.onGetFieldValue('idAlmacen').key;
        var listaSerieProducto = await movimientoService.listarSeriesDisponibles({ idAlmacen: idAlmacen, idProducto: row.idProducto, numeroLote: row.lote });

        this.setState({
            setFieldsValueDetalle,
            getFieldValueDetalle
        }, async () => {
            debugger;
            this.setState({
                agregarSerieVisible: true,
                agregarSerieModal: {
                    ...this.state.agregarSerieModal,
                    idProducto: row.idProducto,
                    codigoProducto: row.codigo,
                    nombreProducto: row.nombre,
                    serie: '',
                    listaDetalleSerie: listaSerieProducto,
                    onCalculateDetail: onCalculateDetail,
                    setFieldsValueDetalle: setFieldsValueDetalle,
                    getFieldValueDetalle: getFieldValueDetalle,
                    selectedRowKeys: row.selectedSerie
                }
            });

        });
    }

    handleChangeSelectedSerie = (selected, rows, onCalculateDetail, idProductoRemoveSerie) => {

        var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle;

        if (selected.length > 0) {
            listaComprobanteDetalle.forEach(detalle => {

                if (detalle.idProducto === rows[0].idProducto) {
                    detalle.selectedSerie = selected;
                    detalle.listaDetalleSerie = rows;
                    detalle.detalleSeries = detalle.listaDetalleSerie.map(u => u.serie).join(', ');
                    detalle.cantidad = detalle.listaDetalleSerie.length;
                    onCalculateDetail(detalle, detalle.idProducto, "arrCantidad", detalle.cantidad, 3);
                }
            });
        } else {
            listaComprobanteDetalle.forEach(detalle => {

                if (detalle.idProducto === idProductoRemoveSerie) {
                    detalle.selectedSerie = [];
                    detalle.listaDetalleSerie = [];
                    detalle.detalleSeries = '';
                    detalle.cantidad = detalle.listaDetalleSerie.length;
                    onCalculateDetail(detalle, detalle.idProducto, "arrCantidad", detalle.cantidad, 3);
                }
            });
        }

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: listaComprobanteDetalle,
                detalleProductos: listaComprobanteDetalle
            },
            agregarSerieModal: {
                ...this.state.agregarSerieModal,
                selectedRowKeys: selected
            }
        });
    };

    async componentDidMount() {

        this._initPagination(this.state.filter, movimientoService.paginacion);
        var idUsuario = auth.user().id;
        const empresa = await empresaService.obtenerPrincipal(0);

        const monedas = await monedaService.listar();
        const tiposCambioDiario = await tipoCambioDiarioService.listarPorFecha(global.fetchCurrentDateStr());
        const listasPrecio = await listaPrecioService.listar();
        const establecimientos = await establecimientoService.principales();
        //const establecimientos = await establecimientoService.principales();
        //const vendedores = await vendedorService.listar();
        const tiposComprobante = await tipoComprobanteService.listar();
        const proyectos = await proyectoService.listar();
        const conceptos = await conceptoService.listar();
        //const entidades = await entidadService.listar();
        // const proveedor_empleado = entidades.filter(item => item.isProveedor || item.isEmpleado);
        const almacenUsuario = await configuracionService.obtenerPermisoEstablecimiento({ idUsuario: idUsuario, idTipoPermiso: 2 }); // 2 logisitica

        const almacen = await almacenService.listarPorIdEstablecimiento(-1);

        const tipoAlmacen = await almacenService.listaTipoEstablecimiento('000001')

        this.setState({
            loadingSource: false,
            tiposCambioDiario: tiposCambioDiario ? tiposCambioDiario : [],
            monedas: monedas ? monedas : [],
            listasPrecio: listasPrecio ? listasPrecio : [],
            establecimientos: establecimientos ? establecimientos : [],
            //vendedores: vendedores ? vendedores : [],
            tiposComprobante: tiposComprobante ? tiposComprobante : [],
            proyectos: proyectos ? proyectos : [],
            //entidades: entidades ? entidades : [],
            conceptos: conceptos ? conceptos.filter(m => { return m.idTipoMovimiento === SALIDA.ID; }) : [],
            TipoAlmacen: tipoAlmacen ? tipoAlmacen : [],
            almacenes: almacen ? almacen : [],
            almacenUsuario: almacenUsuario ? almacenUsuario : [],
            company: empresa
        });
    }

    render() {
        return (
            <div>
                <Header
                    title={this.state.filter.tipoReporte == 1 ? "Salidas" : "Salidas Detallado"}
                    onNew={this.handleNew}
                    loadingNew={this.state.loadingSource}
                    onSearch={() => this._handlePagination(this.state.filter)}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    entidades={this.state.entidades}
                    almacenes={this.state.almacenes}
                    conceptos={this.state.conceptos}
                    estados={this.state.estados}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                    proyectos={this.state.proyectos}

                />
                {this.state.filter.tipoReporte == 1 ?
                    <ResultList
                        pagination={this.state.pagination}
                        loadingEdit={this.state.loadingSource}
                        loadingImprimir={this.state.loadingImprimir}
                        loadingExcel={this.state.loadingExcel}
                        loadingPdf={this.state.loadingPdf}
                        onExportExcel={this.handleExportExcel}
                        onExportPdf={this.handleExportPdf}
                        onPrint={this.handlePrint}
                        onVer={this.handleVer}
                        onEditar={this.handleEdit}
                        onAnular={this.handleAnular}
                        onImprimir={this.handleImprimir}
                        onChange={this._handleChangePagination}
                        flagclaim={this.state.company?.idTipoEmpresa === 2 ? 'show' : 'hide'}
                    /> :
                    <DetalleSalida
                        pagination={this.state.pagination}
                        loadingEdit={this.state.loadingSource}
                        loadingImprimir={this.state.loadingImprimir}
                        loadingExcel={this.state.loadingExcel}
                        loadingPdf={this.state.loadingPdf}
                        onExportExcel={this.handleDetalleExportExcel}
                        onExportPdf={this.handleDetalleExportPdf}
                        onVer={this.handleVer}
                        onImprimir={this.handleImprimir}
                        onChange={this._handleChangePagination}
                        flagclaim={this.state.company?.idTipoEmpresa === 2 ? 'show' : 'hide'}
                    />
                }

                <FormModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onBuscarEntidad={this.handleBuscarEntidad}
                    onChangeEntidad={this.handleOnChangeEntidad}
                    onAgregarDetalle={this.handleAgregarDetalle}
                    onImportarOrdenCompra={this.handleImportarOC}
                    onRemoverProducto={this.handleRemoverProducto}
                    onRemoverReferencia={this.handleRemoverReferencia}
                    onScaner={this.handleScaner}
                    onChangeTab={this.handleChangeTab}
                    onChange={this.handleChangeForm}
                    onBlur={this.handleChangeForm}
                    onAgregarSerie={this.handleAgregarSerie}
                    fetching={this.state.fetching}
                    fetchClientes={this.handleSearchClientes}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}
                    onChangeNameProduct={this.handleChangeNameProduct}
                />

                <SearchProductModal
                    onBuscarProducto={this.handleBuscarProducto}
                    visible={this.state.searchProductVisible}
                    validarStock={this.state.searchProductFormValues.validarStock}
                    dataSource={this.state.searchProductFormValues.dataSource}
                    idSistema={LOGISTICA}//LOGISTICA
                    onSelect={this.handleSelectProduct}
                    onCancel={() => this.setState({ searchProductVisible: false })}
                />
                <ImportarOrdenCompraModal
                    visible={this.state.importarOCVisible}
                    formValues={this.state.importarOrdenCompraModal}
                    onCancel={() => this.setState({ importarOCVisible: false })}
                />
                <FormModalVer
                    visible={this.state.visibleVer}
                    formValues={this.state.formValues}
                    onChangeTab={this.handleChangeTab}
                    onClose={() => this.setState({ visibleVer: false })}
                />
                <RenombrarProductoModal
                    visible={this.state.renombrarProductoVisible}
                    formValues={this.state.renombrarProductoModal}
                    onCancel={() => this.setState({ renombrarProductoVisible: false })}
                    onSaveRename={this.handleOkChangeNameProduct}
                />

                <AgregarSerieModal
                    visible={this.state.agregarSerieVisible}
                    formValues={this.state.agregarSerieModal}
                    onCancel={() => this.setState({ agregarSerieVisible: false })}
                    onAgregarSerieDetalle={this.handleChangeSelectedSerie}
                    onRemove={this.handleRemoverSerieDetalle}
                />

                <ImprimirModal
                    visible={this.state.imprimirVisible}
                    formValues={this.state.imprimirFormValues}
                    onChange={this.handleChangeImprimir}
                    onClose={() => this.setState({ imprimirVisible: false })}
                />
            </div>
        )
    }
}